// General Modules
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import localeIt from "@angular/common/locales/it";
registerLocaleData(localeIt);
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { JwtModule } from "@auth0/angular-jwt";
import { InViewportModule } from "ng-in-viewport";
import { appRoutes } from "./routes";

import { HashLocationStrategy, LocationStrategy } from "@angular/common";

// Extension Modules
import { AgGridModule } from "ag-grid-angular";

import { PdfViewerModule } from 'ng2-pdf-viewer';




import "ag-grid-enterprise";

import { TableModule } from "primeng/table";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { PasswordModule } from "primeng/password";
import { CardModule } from "primeng/card";
import { PanelMenuModule } from "primeng/panelmenu";
import { ChartModule } from "primeng/chart";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { CheckboxModule } from "primeng/checkbox";
import { ListboxModule } from "primeng/listbox";
import { TreeModule } from "primeng/tree";
import { DialogModule } from "primeng/dialog";
import { KeyFilterModule } from "primeng/keyfilter";
import { InputSwitchModule } from "primeng/inputswitch";
import { ToastModule } from "primeng/toast";
import { CarouselModule } from "primeng/carousel";
import { CalendarModule } from "primeng/calendar";
import { PanelModule } from "primeng/panel";
import { SelectButtonModule } from "primeng/selectbutton";
import { SpinnerModule } from "primeng/spinner";
import { InputMaskModule } from "primeng/inputmask";
import { TabViewModule } from "primeng/tabview";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ToggleButtonModule } from "primeng/togglebutton";
import { AccordionModule } from "primeng/accordion";
import { FileUploadModule } from "primeng/fileupload";
import { WebcamModule } from "ngx-webcam";
import { RadioButtonModule } from "primeng/radiobutton";
import { DataViewModule } from "primeng/dataview";
import { VirtualScrollerModule } from "primeng/virtualscroller";
import { InputNumberModule } from "primeng/inputnumber";
import { MultiSelectModule } from "primeng/multiselect";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { SidebarModule } from "primeng/sidebar";
import { DragDropModule } from "primeng/dragdrop";
import { ProgressBarModule } from "primeng/progressbar";
import { GalleriaModule } from "primeng/galleria";
import { SplitButtonModule } from "primeng/splitbutton";
import { ColorPickerModule } from "primeng/colorpicker";
import { TabMenuModule } from "primeng/tabmenu";
import { MegaMenuModule } from "primeng/megamenu";
import { OrganizationChartModule } from "primeng/organizationchart";
import { PickListModule } from "primeng/picklist";
import { SlideMenuModule } from "primeng/slidemenu";
import { BlockUIModule } from "primeng/blockui";
import { MenubarModule } from "primeng/menubar";
import { RippleModule } from "primeng/ripple";
import {FieldsetModule} from 'primeng/fieldset';
import { EditorModule } from 'primeng/editor';
import {AutoCompleteModule} from 'primeng/autocomplete';
import { EmailEditorModule } from 'angular-email-editor';
import { NgxEchartsModule } from 'ngx-echarts';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { TreeTableModule } from 'primeng/treetable';
import {ChipsModule} from 'primeng/chips';


// Bootstrap
import { AppComponent } from "./app.component";
// General
import { LoginComponent } from "./components/general/login/login.component";
import { DashboardComponent } from "./components/general/dashboard/dashboard.component";
import { MenuComponent } from "./components/general/menu/menu.component";
import { HeaderComponent } from "./components/general/header/header.component";
import { HomeComponent } from "./components/general/home/home.component";
// Client Activity - Catalog


// Services
import { AuthService } from "./_services/auth.service";

// Directives
import { AutofocusDirective } from "./_directives/autofocus.directive";

// SYNCFUSION
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { TreeGridModule } from '@syncfusion/ej2-angular-treegrid';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ScheduleModule } from '@syncfusion/ej2-angular-schedule';
import { DiagramModule } from '@syncfusion/ej2-angular-diagrams';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { SplitButtonModule as SplitButtonModuleSyncFusion} from '@syncfusion/ej2-angular-splitbuttons';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor'


import { BtnCellRendererComponent } from "./components/grid-addons/btn-cell-renderer/btn-cell-renderer.component";
import { BtnCellRendererRemoveComponent } from "./components/grid-addons/btn-cell-renderer-remove/btn-cell-renderer-remove.component";
import { ColorCellRendererComponent } from "./components/grid-addons/color-cell-renderer/color-cell-renderer.component";

//Dashboard

import { NgxPageScrollModule } from "ngx-page-scroll";

import { ResponseInterceptorService } from "./_services/response-interceptor.service";
import { ImageCellRendererComponent } from "./components/grid-addons/image-cell-renderer/image-cell-renderer.component";


import { NewsFeedComponent } from './components/general/home/news-feed/news-feed.component';
import { BannerComponent } from './components/general/home/banner/banner.component';
import { RecapComponent } from './components/general/home/recap/recap.component';
import { FeedMsgComponent } from './components/general/home/news-feed/feed-msg/feed-msg.component';
import { SmallCardComponent } from './components/general/home/small-card/small-card.component';
import { BigCardComponent } from './components/general/home/big-card/big-card.component';
import { SettingsDialogComponent } from './components/general/home/settings-dialog/settings-dialog.component';

import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';


import { SurveyCreatorModule } from 'survey-creator-angular';

import { JavaRedirectComponent } from './components/java-redirect/java-redirect.component';
import { SetupHpComponent } from './components/setup-hp/setup-hp.component';
import { SetupHpEditComponent } from './components/setup-hp/setup-hp-edit/setup-hp-edit.component';
import { WidgetDocumentiComponent } from './components/general/home/widget-documenti/widget-documenti.component';
import { BannerkpiComponent } from './components/general/home/banner/bannerkpi/bannerkpi.component';
import { SurveyEditComponent } from './components/surveys/survey-edit/survey-edit.component';
import { SurveysComponent } from './components/surveys/surveys/surveys.component';
import { SurveyModelsComponent } from './components/survey-models/survey-models.component';
import { SurveyModelEditComponent } from './components/survey-models/survey-model-edit/survey-model-edit.component';
import { RsaComponent } from './components/rsa/rsa.component';
import { TargetsComponent } from './components/targets/targets.component';
import { TargetEditComponent } from './components/targets/target-edit/target-edit.component';
import { SurveyStartupModelEditComponent } from './components/survey-startup-models/survey-startup-model-edit/survey-startup-model-edit.component';
import { SurveyStartupModelsComponent } from './components/survey-startup-models/survey-startup-models.component';
import { EmailCampaignsComponent } from './components/email-campaigns/email-campaigns.component';
import { CampaignEditComponent } from './components/email-campaigns/campaign-edit/campaign-edit.component';
import { SmsComponent } from './components/sms/sms.component';
import { SmsEditComponent } from './components/sms/sms-edit/sms-edit.component';
import { RsaEditComponent } from './components/rsa/rsa-edit/rsa-edit.component';

import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { ChecklModelsComponent } from './components/checklists/checkl-models/checkl-models.component';
import { ChecklModelEditComponent } from './components/checklists/checkl-model-edit/checkl-model-edit.component';
import { ChecklEditComponent } from './components/checklists/checkl-edit/checkl-edit.component';
import { ChecklComponent } from './components/checklists/checkl/checkl.component';
import { ChecklResultsComponent } from './components/checklists/checkl-results/checkl-results.component';

import { SurveysResultsComponent } from './components/surveys/surveys-results/surveys-results.component';
import { OrdiniComponent } from './components/ordini/ordini.component';
import { ManutenzioniComponent } from './components/manutenzioni/manutenzioni.component';
import { TicketsComponent } from './components/tickets/tickets.component';
import { RecruitingComponent } from './components/recruiting/recruiting.component';
import { ArkiguestComponent } from './components/arkiguest/arkiguest.component';
import { SegnalazioniComponent } from './components/segnalazioni/segnalazioni.component';
import { NonconformitaComponent } from './components/nonconformita/nonconformita.component';
import { GridtooltipComponent } from './components/general/grid-addons/gridtooltip/gridtooltip.component';
import { SurveyModelSettingsComponent } from './components/survey-models/survey-model-settings/survey-model-settings.component';
import { SurveyResultsPptxComponent } from './components/surveys/surveys/survey-results-pptx/survey-results-pptx.component';
import { SurveysEmailsnotsentComponent } from './components/surveys/surveys-emailsnotsent/surveys-emailsnotsent.component';
import { OrganizationComponent } from './components/admin/organization/organization.component';
import { AutoCompleteModule as SyncFusionAutoCompleteModule} from '@syncfusion/ej2-angular-dropdowns';
import { AdminComponent } from './components/admin/admin.component';
import { ArkiwebappsComponent } from './components/admin/arkiwebapps/arkiwebapps.component';
import { ArkiwebrolesComponent } from './components/admin/arkiwebroles/arkiwebroles.component';
import { KpitreeComponent } from './components/admin/kpitree/kpitree.component';
import { SurveysimportsComponent } from './components/surveys/surveysimports/surveysimports.component';
import { SurveyimportEditComponent } from './components/surveys/surveysimports/surveyimport-edit/surveyimport-edit.component';
import { TodolistComponent } from './components/todolist/todolist.component';
import { DaApprovareComponent } from './components/da-approvare/da-approvare.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { OrganizationdiagramComponent } from './components/admin/organizationdiagram/organizationdiagram.component';
import { QualificheutentiComponent } from './components/admin/qualificheutenti/qualificheutenti.component';
import { SurveyCompilationsComponent } from "./components/surveys/surveycompilations/surveycompilations.component";
import { SurveyViewCompilationComponent } from "./components/surveys/surveyviewcompilation/surveyviewcompilation.component";
import { SurveyStartupModelSettingsComponent } from './components/survey-startup-models/survey-startup-model-settings/survey-startup-model-settings.component';
import { MonitorsComponent } from './components/monitors/monitors.component';
import { MonitorEditComponent } from './components/monitors/monitor-edit/monitor-edit.component';
import { RulesComponent } from './components/monitors/rules/rules.component';
import { RuleEditComponent } from './components/monitors/rules/rule-edit/rule-edit.component';
import { PlaylistsComponent } from './components/monitors/playlists/playlists.component';
import { PlaylistEditComponent } from './components/monitors/playlists/playlist-edit/playlist-edit.component';
import { RicetteComponent } from './components/gestione-mensa/ricette/ricette.component';
import { TbComponent } from './_helpers/tablecomponent/tb/tb.component';
import { PrenotazioniComponent } from './components/gestione-mensa/prenotazioni/prenotazioni.component';
import { ProgrammazioneComponent } from './components/gestione-mensa/programmazione/programmazione.component';
import { RicetteEditComponent } from './components/gestione-mensa/ricette/ricette-edit/ricette-edit.component';


import { ReactiveFormsModule } from '@angular/forms';
import { ProgrammazioneEditComponent } from './components/gestione-mensa/programmazione/programmazione-edit/programmazione-edit.component';
import { ProgrammazioneCalendarComponent } from './components/gestione-mensa/programmazione/programmazione-calendar/programmazione-calendar.component';
import { ProgrammaComponent } from './components/gestione-mensa/programma/programma.component';
import { ProgrammaEditComponent } from './components/gestione-mensa/programma/programma-edit/programma-edit.component';
import { SetupComponent } from './components/gestione-mensa/setup/setup.component';
import { TipimonitorsComponent } from './components/monitors/tipimonitors/tipimonitors.component';
import { MonitorReportComponent } from './components/monitors/monitor-report/monitor-report.component';
import { MonitorSetupComponent } from './components/monitors/monitor-setup/monitor-setup.component';
import { AppsComponent } from './components/admin/apps/apps.component';
import { ApppermitEditComponent } from './components/admin/apppermit-edit/apppermit-edit.component';
import { AppEditComponent } from './components/admin/app-edit/app-edit.component';
import { SospensioniComponent } from './components/gestione-mensa/sospensioni/sospensioni.component';
import { SospensioniEditComponent } from './components/gestione-mensa/sospensioni/sospensioni-edit/sospensioni-edit.component';
import { CapienzeComponent } from './components/gestione-mensa/capienze/capienze.component';



@NgModule({
  declarations: [
    AppComponent,
    AutofocusDirective,
    LoginComponent,
    DashboardComponent,
    MenuComponent,
    HeaderComponent,
    
    HomeComponent,

    NewsFeedComponent,
    FeedMsgComponent,
    BannerComponent,
    RecapComponent,

    SmallCardComponent,
    BigCardComponent,
    SettingsDialogComponent,
    //Dashboard

    CheckboxRenderer,

    JavaRedirectComponent,
    SetupHpComponent,
    SetupHpEditComponent,
    WidgetDocumentiComponent,
    BannerkpiComponent,
    SurveyEditComponent,
    SurveysComponent,
    SurveyModelsComponent,
    SurveyModelEditComponent,
    RsaComponent,
    TargetsComponent,
    TargetEditComponent,
    SurveyStartupModelEditComponent,
    SurveyStartupModelsComponent,
    EmailCampaignsComponent,
    CampaignEditComponent,
    SmsComponent,
    SmsEditComponent,
    RsaEditComponent,
    ChecklModelsComponent,
    ChecklModelEditComponent,
    ChecklEditComponent,
    ChecklComponent,
    ChecklResultsComponent,
    SurveysResultsComponent,
    OrdiniComponent,
    ManutenzioniComponent,
    TicketsComponent,
    RecruitingComponent,
    ArkiguestComponent,
    SegnalazioniComponent,
    NonconformitaComponent,
    GridtooltipComponent,
    SurveyModelSettingsComponent,
    SurveyResultsPptxComponent,
    SurveyCompilationsComponent,
    SurveyViewCompilationComponent,
    SurveysEmailsnotsentComponent,
    OrganizationComponent,
    AdminComponent,
    ArkiwebappsComponent,
    ArkiwebrolesComponent,
    KpitreeComponent,
    SurveysimportsComponent,
    SurveyimportEditComponent,
    TodolistComponent,
    DaApprovareComponent,
    CalendarComponent,
    OrganizationdiagramComponent,
    QualificheutentiComponent,
    SurveyStartupModelSettingsComponent,
    MonitorsComponent,
    MonitorEditComponent,
    RulesComponent,
    RuleEditComponent,
    PlaylistsComponent,
    PlaylistEditComponent,
    RicetteComponent,
    TbComponent,
    PrenotazioniComponent,
    CapienzeComponent,
    SospensioniComponent,
    SospensioniEditComponent,
    ProgrammazioneComponent,
    RicetteEditComponent,
    ProgrammazioneEditComponent,
    ProgrammazioneCalendarComponent,
    ProgrammaComponent,
    ProgrammaEditComponent,
    SetupComponent,
    TipimonitorsComponent,
    MonitorReportComponent,
    MonitorSetupComponent,
    AppsComponent,
    ApppermitEditComponent,
    AppEditComponent,
    
  ],
  imports: [
    BrowserModule,
    GridModule,
    TreeGridModule,
    DropDownListModule,
    DiagramModule,
    ToolbarModule,
    SplitButtonModuleSyncFusion,
    ScheduleModule,
    PdfViewerModule,
    BrowserAnimationsModule,
    FormsModule,

    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),
    JwtModule.forRoot({
      config: {
        tokenGetter: function tokenGetter() {
          return localStorage.getItem("login_token");
        },
        // whitelistedDomains: ['localhost:4200']
        // blacklistedRoutes: ['http://localhost:4200/auth/login']
      },
    }),
   
    AgGridModule.withComponents([
      BtnCellRendererComponent,
      BtnCellRendererRemoveComponent,
      ColorCellRendererComponent,
      ImageCellRendererComponent
    ]),
    SurveyCreatorModule,
    NgxPageScrollModule,
    TableModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    ButtonModule,
    PasswordModule,
    CardModule,
    PanelMenuModule,
    ChartModule,
    ProgressSpinnerModule,
    MessagesModule,
    MessageModule,
    BreadcrumbModule,
    CheckboxModule,
    ListboxModule,
    TreeModule,
    DialogModule,
    KeyFilterModule,
    InputSwitchModule,
    ToastModule,
    CarouselModule,
    CalendarModule,
    PanelModule,
    SelectButtonModule,
    SpinnerModule,
    InputMaskModule,
    TabViewModule,
    ScrollPanelModule,
    ToggleButtonModule,
    InViewportModule,
    AccordionModule,
    FileUploadModule,
    WebcamModule,
    RadioButtonModule,
    DataViewModule,
    VirtualScrollerModule,
    InputNumberModule,
    TooltipModule,
    RichTextEditorAllModule,
    MultiSelectModule,
    ConfirmDialogModule,
    OverlayPanelModule,
    SidebarModule,
    DragDropModule,
    ProgressBarModule,
    GalleriaModule,
    SplitButtonModule,
    ColorPickerModule,
    TabMenuModule,
    MegaMenuModule,
    OrganizationChartModule,
    PickListModule,
    SlideMenuModule,
    BlockUIModule,
    MenubarModule,
    RippleModule,
    FieldsetModule,
    EditorModule,
    SyncFusionAutoCompleteModule,
    AutoCompleteModule,
    EmailEditorModule,
    IvyCarouselModule,
    TreeTableModule,
    ChipsModule,
    NgxQRCodeModule,
    ReactiveFormsModule,
    NgxEchartsModule.forRoot({
        echarts: () => import('echarts'),
    }),
  ],
  providers: [
    AuthService,
    { provide: LOCALE_ID, useValue: "it-IT" },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
